export const requirementExceptions = {
  changeStatusRequirementByID:
    "Error al cambiar el estado del requisito con determinado id",
  fetchStatusRequirementByID:
    "Error al obtener el estado del requisito con determinado id",
  fetchRequirementById: "Error al obtener el requisito con determinado id",
  removeRequirementFile: "Error al eliminar el archivo del requisito",
  downloadRequirementFile: "Error al descargar el archivo del requisito",
  previewFileByURL: "Error al previsualizar el archivo del requisito",
  onCompleteDigitalSignature: "Error al completar la firma digital",
  onRemoveRequirement: "Error al eliminar el requisito",
  verifyRequirement: "Error al verificar el requisito",
};
